import React from 'react';
import { Button } from '@/components/ui/button';
import type { QuickFilterDefinition } from '../types';
import { cn } from '@/lib/utils';

export interface FilterChipsProps {
  filters: QuickFilterDefinition[];
  activeIds: string[];
  onToggle: (id: string) => void;
}

export const FilterChips: React.FC<FilterChipsProps> = ({ filters, activeIds, onToggle }) => {
  if (!filters?.length) return null;
  return (
    <div className="px-6 py-3 border-b border-gray-200 bg-white flex flex-wrap gap-2">
      {filters.map((f) => {
        const active = activeIds.includes(f.id);
        return (
          <Button
            key={f.id}
            type="button"
            variant={active ? 'default' : 'outline'}
            size="sm"
            className={cn(
              'h-8',
              active ? 'bg-sky-600 text-white hover:bg-sky-700' : 'border-gray-200 text-gray-700'
            )}
            onClick={() => onToggle(f.id)}
          >
            {f.label}
          </Button>
        );
      })}
    </div>
  );
};
